<template>
  <div :class="item === 'instructor' ? 'koc-skeleton-loader-no-shadow' : 'koc-skeleton-loader'">
    <div
      v-if="item === 'insider'"
      class="koc-skeleton-loader-insider"
    >
      <div class="koc-skeleton-loader-header">
        <div class="koc-skeleton-loader-header-title" />
        <div class="koc-skeleton-loader-header-link" />
      </div>
      <div class="koc-skeleton-loader-image">
        <div
          class="koc-card-image-thumbnail"
        />
      </div>
      <div class="koc-skeleton-loader-content">
        <div class="koc-skeleton-loader-content-title" />
        <div class="koc-skeleton-loader-content-body" />
      </div>
      <div class="koc-skeleton-loader-insider-secondary">
        <div class="koc-skeleton-loader-insider-secondary-image">
          <div
            class="koc-skeleton-loader-insider-secondary-image-thumbnail"
          />
        </div>
        <div class="koc-skeleton-loader-insider-secondary-content">
          <div class="koc-skeleton-loader-insider-secondary-content-title" />
          <div class="koc-skeleton-loader-insider-secondary-content-body" />
        </div>
      </div>
    </div>
    <div
      v-if="item === 'community'"
      class="koc-skeleton-loader-community"
    >
      <div class="koc-skeleton-loader-header">
        <div class="koc-skeleton-loader-header-title" />
        <div class="koc-skeleton-loader-header-link" />
      </div>
      <div class="koc-skeleton-loader-community-content">
        <div
          v-for="topic in communityTopics"
          :key="topic"
          class="koc-skeleton-loader-community-content-body"
        />
      </div>
    </div>
    <div
      v-if="item === 'magazine'"
      class="koc-skeleton-loader-magazine"
    >
      <div class="koc-skeleton-loader-magazine-image" />
      <div class="koc-skeleton-loader-magazine-content">
        <div class="koc-skeleton-loader-magazine-content-title" />
        <div class="koc-skeleton-loader-magazine-content-published" />
        <div class="koc-skeleton-loader-magazine-content-body" />
        <div class="koc-skeleton-loader-magazine-content-footer">
          <div class="koc-skeleton-loader-magazine-content-footer-links">
            <div class="koc-skeleton-loader-magazine-content-footer-links-link" />
          </div>
          <div class="koc-skeleton-loader-magazine-content-footer-icons">
            <div class="koc-skeleton-loader-magazine-content-footer-icons-icon" />
            <div class="koc-skeleton-loader-magazine-content-footer-icons-icon" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="item === 'form'"
      class="koc-skeleton-loader-form"
    >
      <div class="koc-flex">
        <div class="koc-skeleton-loader-form-input" />
        <div class="koc-skeleton-loader-form-input" />
      </div>
      <div class="koc-flex">
        <div class="koc-skeleton-loader-form-input" />
        <div class="koc-skeleton-loader-form-input" />
      </div>
      <div class="koc-flex">
        <div class="koc-skeleton-loader-form-input" />
      </div>
    </div>
    <div
      v-if="item === 'event-livecard'"
      class="koc-skeleton-loader-event-livecard"
    >
      <div class="koc-skeleton-loader-event-livecard-track" />
      <div class="koc-flex-column">
        <div class="koc-skeleton-loader-event-livecard-text" />
        <div class="koc-skeleton-loader-event-livecard-text" />
        <div class="koc-skeleton-loader-event-livecard-text" />
      </div>
      <div class="koc-skeleton-loader-event-livecard-button" />
    </div>
    <div
      v-if="item === 'instructor'"
      class="koc-skeleton-loader-instructor-card"
    >
      <div class="koc-skeleton-loader-instructor-card-image" />
      <div class="koc-skeleton-loader-instructor-card-content">
        <div class="koc-skeleton-loader-instructor-card-content-title" />
        <div
          v-if="isMobile"
          class="koc-skeleton-loader-instructor-card-content-excerpt"
        />
      </div>
    </div>
    <div
      v-if="header"
      class="koc-skeleton-loader-header"
    >
      <div class="koc-skeleton-loader-header-title" />
      <div class="koc-skeleton-loader-header-link" />
    </div>
    <div
      v-if="image"
      class="koc-skeleton-loader-image"
    >
      <div
        class="koc-card-image-thumbnail"
      />
    </div>
    <div
      v-if="content"
      class="koc-skeleton-loader-content"
    >
      <div class="koc-skeleton-loader-content-title" />
      <div
        v-for="body in contentBody"
        :key="body"
        class="koc-skeleton-loader-content-body"
      />
      <div
        v-if="contentBodyFlex"
        class="koc-skeleton-loader-content-flex"
      >
        <div class="koc-skeleton-loader-content-flex-left" />
        <div class="koc-skeleton-loader-content-flex-right" />
      </div>
    </div>
    <div
      v-if="footer"
      class="koc-skeleton-loader-footer"
    >
      <div class="koc-skeleton-loader-footer-links">
        <div
          v-for="link in footerLinks"
          :key="link"
          class="koc-skeleton-loader-footer-links-link"
        />
      </div>
      <div class="koc-skeleton-loader-footer-icons">
        <div
          v-for="icon in footerIcons"
          :key="icon"
          class="koc-skeleton-loader-footer-icons-icon"
        />
      </div>
    </div>
    <div
      v-if="grid"
      class="koc-skeleton-loader-grid"
    >
      <div class="koc-skeleton-loader-grid-container">
        <div
          v-for="(row, index) in gridRows"
          :key="index"
          class="koc-skeleton-loader-grid-container-row"
        >
          <div
            v-for="(column, index) in gridColumns"
            :key="index"
            class="koc-skeleton-loader-grid-container-column"
            :style="{flexBasis: `${100/gridColumns}%`}"
          >
            <p class="koc-skeleton-loader-grid-container-block" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./skeleton-loader.js"></script>
<style lang="scss" scoped src="./skeleton-loader.scss"></style>
